export default __webpack_public_path__ + "static/media/op_sshot.5d11a537.svg";